import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import { CourseDirectory } from "@/modules/learningCenter/features/CourseDirectory/components/CourseDirectory/CourseDirectory";
import { CourseDetail } from "@/modules/learningCenter/features/CourseDirectory/components/CourseDetail/CourseDetail";
import { CoursePlayer } from "@/modules/learningCenter/features/CourseDirectory/components/CoursePlayer/CoursePlayer";
import { MyCourses } from "@/modules/learningCenter/features/MyCourses/components/MyCourses/MyCourses";

// Stable component reference for the Learning Center app shell.
const LearningCenterMainLayout = () => <MainLayout section="learning-center" />;

/**
 * LearningCenterRoutes
 *
 * Member-facing Learning Center surfaces. No permission gate — these are
 * available to all authenticated users (only the Auth0 authentication guard
 * applies). The catalog (WI-04), the enrollment-gated course detail/viewer and
 * player, and the "My Courses" transcript (WI-05) all live here.
 */
const LearningCenterRoutes = (
  <>
    {/* Standard surfaces, wrapped in the app shell (AppStrip + sidebar + top
        nav). */}
    <Route
      element={<AuthenticationGuard component={LearningCenterMainLayout} />}
      path="/hub/learning-center"
    >
      <Route element={<CourseDirectory />} path="courses" />
      <Route element={<MyCourses />} path="my-courses" />
      <Route element={<CourseDetail />} path="courses/:uuid" />
    </Route>

    {/* Focused learning mode. The player renders OUTSIDE MainLayout so it can
        fill the viewport with its own slim branded top bar (the Udemy /
        Coursera "learning mode" pattern), rather than sitting in the normal
        page padding under the app header. Only the authentication guard
        applies — the app shell for every other route is untouched. */}
    <Route
      element={<AuthenticationGuard component={CoursePlayer} />}
      path="/hub/learning-center/courses/:courseUuid/modules/:moduleUuid"
    />
  </>
);

export default LearningCenterRoutes;
